import Resources from "./resources/Resources";
import Sparks from "./sparks/Sparks";
import SparkRatings from "../../../components/SparkRatings";

export default function Materials() {
    return(<div className="standard-padding page-xl-centered showing">
        <Sparks/>
        <div className="v-spacer-3xl"></div>
        <p className="section-title v-spacer-m">Spark Ratings</p>
        <SparkRatings showCompany/>
        <div className="v-spacer-3xl"></div>
        <Resources/>
    </div>)
}